export default __webpack_public_path__ + "static/media/Screenshot (1169) 1.ff123026.png";